import { FormFieldsGeneratorService } from './../form-helpers/form-fields-generator.service';
import { Component, OnInit } from '@angular/core';
import { DeliveryFormOutputState, DeliveryFormStateService } from '../form-state/delivery-form-state.service';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../form-state/form-state-change.service';
import { slideInOut } from '../../utils/animations/slides.animation';
import { FormFieldsMasks } from '../field-mask/form-fields-masks';
import { FormGroup } from '@angular/forms';
import { UserDataFormService } from './user-data-form.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';


@Component({
  selector: 'user-data-installation-address-component',
  templateUrl: './user-data-installation-address.component.html',
  animations: [slideInOut]
})

export class UserDataInstallationAddressComponent implements OnInit {
  public showOtherInstallationAddressSection = false;
  public showInstallationAddressForm = false;
  public formFields: any;
  public formGroups: { [s: string]: FormGroup } = {};
  public activeForm: FormGroup;

  constructor(
    private deliveryFormState: DeliveryFormStateService,
    private formStateChangeService: FormStateChangeService,
    private userDataFormService: UserDataFormService,
    private commonInfo: CommonInfoService,
    private slot: SlotService,
    private formsGenerator: FormFieldsGeneratorService,
    public validationMasks: FormFieldsMasks,
  ) {
    this.formFields = this.userDataFormService.formFields;

    this.showOtherInstallationAddressSection = this.slot.hasM2mCardInCart() && !this.commonInfo.isMigrationOffer && !this.commonInfo.isOtherSalesOffer;

    this.deliveryFormState.subscribe(
      (deliveryFormOutputState: DeliveryFormOutputState): void => {
        this.showInstallationAddressForm = deliveryFormOutputState.isInstallationAddressFormVisible;
      });

    if (this.showOtherInstallationAddressSection) {
      this.formsGenerator.addInstallationAddressFormControl();
    }
  }

  ngOnInit(): void {
    this.formsGenerator.watchActiveForm().subscribe(form => {
      this.activeForm = form;
      this.showInstallationAddressForm = this.activeForm?.get('installationAddressOption')?.value === 'on';
    });
  }

  public onOtherInstallationAddressClick($event: any): void {
    this.toggleOtherInstallationAddress($event.target.checked);

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.INSTALLATION_OTHER_ADDRESS_CHECKBOX,
        $event.target.checked
      )
    );
  }

  private toggleOtherInstallationAddress(shouldShow: boolean): void {
    this.formsGenerator.toggleExpandedFormGroupVisibility('installationAddress', this.activeForm, !shouldShow, shouldShow);
  }
}
